export default __webpack_public_path__ + "static/media/analytics-page-light.4145a602.png";